import { graphql } from '@/gql';
import type { SearchGroceryItemsV2QueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { PaginatedGrocerySearchItemTypeResponse } from '@/models/grocery';

// Fragments
import './fragments/grocerySearchItemFragment';

export const searchGroceryItemsV2 = async ({
  retailerSlug,
  postalCode,
  latitude,
  longitude,
  country,
  query,
}: SearchGroceryItemsV2QueryVariables) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      retailerSlug,
      postalCode,
      latitude,
      longitude,
      country,
      query,
    },
    query: graphql(`
      query SearchGroceryItemsV2(
        $retailerSlug: String!
        $postalCode: String!
        $latitude: Float!
        $longitude: Float!
        $country: String!
        $query: String!
      ) {
        searchGroceryItemsV2(
          retailerSlug: $retailerSlug
          postalCode: $postalCode
          latitude: $latitude
          longitude: $longitude
          country: $country
          query: $query
        ) {
          ...GrocerySearchItemFragment
        }
      }
    `),
  });

  return response.data.searchGroceryItemsV2 as PaginatedGrocerySearchItemTypeResponse;
};
